import { AdserverRequestId, CreativeBeaconType } from '../types';
import { dispatchCreativeNotifications } from './creativeNotifications';

export const dispatchVideoImpressionNotifications = (arid: AdserverRequestId) => {
  return dispatchCreativeNotifications({
    arid,
    beaconType: CreativeBeaconType.VideoImpression
  });
};
